import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '../../common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';

export type CrawlRequestBody = Record<string, unknown> & {
  domain_slug: string | null | undefined;
};

export type CrawlCountArg = {
  job_page: string | number | null | undefined;
  domain_slug: string | null | undefined;
};

const crawlApi = createApi({
  baseQuery: (...args) =>
    customFetchBase(getBaseApiPath(), ...args),
  tagTypes: ['CrawlHistory', 'UrlInfo', 'PAGE_ISSUE', 'CHECKLIST'],
  endpoints: () => ({})
});

export default crawlApi;
